export const ROUTE_CHANGE = 'ROUTE_CHANGE';

export const routeChange = (routeName, params = {}) => ({
  type: ROUTE_CHANGE,
  routeName,
  params,
});
